/**
 * Transforms an array of backend partner data into a format suitable for chart options.
 * Each item in the input array is mapped to an object containing an ID, name, and a value
 * derived from the partner's total amount statistics.
 * @param {Array<object>} backendData - An array of objects, where each object represents
 * a partner and is expected to have the following structure:
 * `{ id: string | number, name: string, statistics: { total_amount: number, ... } }`.
 * @param {string} attribute - The attribute to display on the chart (e.g., 'total_amount', 'total_earnings', 'total_count').
 * @returns {Array<object>} An array of objects, each with `id`, `name`, and `value` properties.
 * Example: `[{ id: '123', name: 'Partner A', value: 1500 }, ...]`.
 */
export function calculatePartnersChartOptions(backendData, attribute) {
  return backendData.map((item) => ({
    id: item.id,
    name: item.name,
    value: item.statistics[attribute],
  }));
}
